import { useFeedbackContext } from '../lib/feedback.context';

export function useFeedback() {
  return useFeedbackContext();
}